module.exports = __webpack_public_path__ + "static/media/shape1_0.8ac67e1d.obj";